var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */
import { Component, h } from 'preact';
import { bem } from '@nrk/dh-utils';
import { AvatarImage } from './AvatarImage';

var styles = {
  'chatLog': 'dhfc-1_0_0-beta_11-chatLog',
  'avatarImage': 'dhfc-1_0_0-beta_11-avatarImage',
  'avatar': 'dhfc-1_0_0-beta_11-avatar',
  'avatar__placeholder': 'dhfc-1_0_0-beta_11-avatar__placeholder',
  'avatar--right': 'dhfc-1_0_0-beta_11-avatar--right',
  'date': 'dhfc-1_0_0-beta_11-date',
  'date--isFirst': 'dhfc-1_0_0-beta_11-date--isFirst',
  'message': 'dhfc-1_0_0-beta_11-message',
  'message--left': 'dhfc-1_0_0-beta_11-message--left',
  'message--showAvatar': 'dhfc-1_0_0-beta_11-message--showAvatar',
  'message--right': 'dhfc-1_0_0-beta_11-message--right',
  'message--isLastInGroup': 'dhfc-1_0_0-beta_11-message--isLastInGroup',
  'message__text': 'dhfc-1_0_0-beta_11-message__text',
  'message__text--right': 'dhfc-1_0_0-beta_11-message__text--right',
  'message__text--left': 'dhfc-1_0_0-beta_11-message__text--left',
  'message__image': 'dhfc-1_0_0-beta_11-message__image',
  'message__image--expanded': 'dhfc-1_0_0-beta_11-message__image--expanded',
  'message__image--clickable': 'dhfc-1_0_0-beta_11-message__image--clickable',
  'message__image--hover': 'dhfc-1_0_0-beta_11-message__image--hover',
  'message__image--left': 'dhfc-1_0_0-beta_11-message__image--left',
  'message__image--right': 'dhfc-1_0_0-beta_11-message__image--right',
  'message__name': 'dhfc-1_0_0-beta_11-message__name',
  'message__content': 'dhfc-1_0_0-beta_11-message__content',
  'message__content--left': 'dhfc-1_0_0-beta_11-message__content--left',
  'message__content--right': 'dhfc-1_0_0-beta_11-message__content--right',
  'message__content--showName': 'dhfc-1_0_0-beta_11-message__content--showName'
};


export var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: 'render',
    value: function render() {
      var person = this.props.person;
      var name = person.name,
          image = person.image;

      var displayImage = image && image.type !== 'none';
      return h(
        'div',
        { 'aria-hidden': true, className: bem(styles.avatar, person.side) },
        displayImage && h(AvatarImage, { image: image, alt: person.name, title: person.name }),
        !displayImage && h(
          'span',
          { className: styles.avatar__placeholder, title: name },
          getInitials(name)
        )
      );
    }
  }]);

  return Avatar;
}(Component);

function getInitials() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var initials = name.trim().split(/[ -]/).map(function (item) {
    return item.charAt(0).toUpperCase();
  });

  if (initials.length < 2) return initials[0];
  return [initials[0], initials[initials.length - 1]].join('');
}